const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricetracqPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.542,
    height: 24.981,
    viewBox: "0 0 21.542 24.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9112"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26468",
    d: "M52.61 50a12.053 12.053 0 0 0-3.39 8.03h1.265c0-.108.013-.266.028-.456a11.5 11.5 0 0 1 .805-3.388 11 11 0 0 1 1.542-2.619c.239-.3.458-.545.619-.718z",
    transform: "translate(-49.22 -47.151)",
    style: {
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26469",
    d: "m74.58 54.54.082.139c.361.57.836.76 1.341.323a12.064 12.064 0 0 1 2.866-1.932",
    transform: "translate(-69.764 -49.638)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#3f8edd",
      strokeWidth: "1.2px",
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26470",
    d: "m77.5 54.154.234.325a.49.49 0 0 0 .7.1l1.115-.877",
    transform: "translate(-72.129 -50.148)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#3f8edd",
      strokeWidth: "1.2px",
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26471",
    d: "m104.13 58.721 1.474-2.555c.226-.393.446-.788.686-1.172a.321.321 0 0 1 .243-.144 7.432 7.432 0 0 1 5.728 3.717c.025.042.04.087.072.154z",
    transform: "translate(-93.701 -51.08)",
    style: {
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26472",
    d: "m128.9 84.455-4.1-7.1c.1 0 .169-.017.239-.017h4.028c.146 0 .249.017.313.175a7.475 7.475 0 0 1-.4 6.838.809.809 0 0 1-.08.104z",
    transform: "translate(-110.445 -69.298)",
    style: {
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26473",
    d: "M78 113.18h8.2c-.15.262-.283.5-.418.739-.57.974-1.14 1.943-1.685 2.923a.342.342 0 0 1-.412.205 7.481 7.481 0 0 1-5.641-3.749.655.655 0 0 1-.044-.118z",
    transform: "translate(-72.534 -98.331)",
    style: {
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26474",
    d: "M82.548 61.612c-.743-1.286-1.457-2.53-2.179-3.766-.089-.152 0-.236.066-.332a7.4 7.4 0 0 1 4.454-2.849c.57-.118 1.14-.146 1.709-.215l.038.087z",
    transform: "translate(-74.424 -50.756)",
    style: {
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26475",
    d: "M115.768 96.29c.38.665.748 1.288 1.109 1.911s.691 1.208 1.045 1.808a.256.256 0 0 1 0 .334 7.464 7.464 0 0 1-5.178 3.018c-.266.032-.534.036-.8.053h-.283z",
    transform: "translate(-99.801 -84.649)",
    style: {
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26476",
    d: "M78.238 80.678h-3.9c-.642 0-.648 0-.864-.615a7.487 7.487 0 0 1 .418-6.116c.065-.125.141-.243.23-.4z",
    transform: "translate(-68.494 -66.228)",
    style: {
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26477",
    d: "M81.619 45.359a11.476 11.476 0 0 0-1.419-4.526 10.674 10.674 0 0 0-12.95-5.223 7.822 7.822 0 0 0-3.75 2.262l1.4 2.251a9.481 9.481 0 0 1 1.785-1.639c.19-.135.38-.256.57-.368a.821.821 0 0 1 1.14.323l.222.422a8.182 8.182 0 0 1 1.916-.64 8.318 8.318 0 0 1 2-.15 8.786 8.786 0 0 1 4.993 2.006 8.408 8.408 0 0 1 2.777 5.487 8.184 8.184 0 0 1-13.672 6.726 8.391 8.391 0 0 1-2-2.817 8.182 8.182 0 0 1 .61-7.6l-.8-1.155c-.093.127-.213.3-.346.519a9.5 9.5 0 0 0 .1 10.186 35.544 35.544 0 0 0 7.069 8.251 1.309 1.309 0 0 0 1.755-.021 45.358 45.358 0 0 0 7.088-8.186c.152-.23.287-.456.4-.674a9.421 9.421 0 0 0 .76-1.861 10.1 10.1 0 0 0 .349-3.575z",
    transform: "translate(-60.111 -35.023)",
    style: {
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26478",
    d: "M70.259 38.465c.19-.135.38-.256.57-.368a.821.821 0 0 1 1.14.323l.222.422a8.357 8.357 0 0 1 1.392-.517 8.68 8.68 0 0 1 2.83-.477 9.26 9.26 0 0 1 8.306 5.181 12.093 12.093 0 0 0-.95-2.226 10.674 10.674 0 0 0-12.95-5.223 7.862 7.862 0 0 0-3.749 2.268l1.4 2.251a9.482 9.482 0 0 1 1.789-1.634z",
    transform: "translate(-63.68 -34.999)",
    style: {
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26479",
    d: "M105.259 50a8.982 8.982 0 0 0-2.579.412 9.558 9.558 0 0 1 6.925 1.081c2.5 1.356 3.259 2.283 3.962 3.713A9.359 9.359 0 0 0 105.259 50z",
    transform: "translate(-92.527 -47.151)",
    style: {
      fill: "#3f8edd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricetracqPin);
export default __webpack_public_path__ + "static/media/pricetracq-pin.14c7c7d09894f0932c5796da1da2cda9.svg";
export { ForwardRef as ReactComponent };